/* eslint-disable */
// @generated by protobuf-ts 2.10.0 with parameter use_proto_field_name,ts_nocheck,eslint_disable,long_type_string
// @generated from protobuf file "common/v3/generic/core.proto" (package "fubo.tv.proto.common.v3.generic", syntax proto2)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message fubo.tv.proto.common.v3.generic.Core
 */
export interface Core {
    /**
     * @generated from protobuf field: optional string app_session_id = 1;
     */
    app_session_id?: string;
    /**
     * @generated from protobuf field: string event_id = 2;
     */
    event_id: string;
    /**
     * @generated from protobuf field: string event_name = 3;
     */
    event_name: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp event_time = 4;
     */
    event_time?: Timestamp;
    /**
     * @generated from protobuf field: string market = 5;
     */
    market: string;
    /**
     * @generated from protobuf field: optional string profile_id = 6;
     */
    profile_id?: string;
    /**
     * @generated from protobuf field: string spec_version = 7;
     */
    spec_version: string;
    /**
     * @generated from protobuf field: optional string x_forwarded_for = 8;
     */
    x_forwarded_for?: string;
    /**
     * @generated from protobuf field: optional int64 app_session_start = 9;
     */
    app_session_start?: string;
    /**
     * @generated from protobuf field: optional string app_session_replay_id = 10;
     */
    app_session_replay_id?: string;
    /**
     * @generated from protobuf field: optional string user_tier = 11;
     */
    user_tier?: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class Core$Type extends MessageType<Core> {
    constructor() {
        super("fubo.tv.proto.common.v3.generic.Core", [
            { no: 1, name: "app_session_id", kind: "scalar", localName: "app_session_id", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "123", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Session ID." } },
            { no: 2, name: "event_id", kind: "scalar", localName: "event_id", T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "123", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "ID used to identify an event." } },
            { no: 3, name: "event_name", kind: "scalar", localName: "event_name", T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "dvr_add", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Event Name." } },
            { no: 4, name: "event_time", kind: "message", localName: "event_time", T: () => Timestamp, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "2023-07-12T11:03:12+02:00", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Timestamp of event in RFC 3339 format." } },
            { no: 5, name: "market", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "USA", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "ISO 3166-1 alpha-3 codes for countries." } },
            { no: 6, name: "profile_id", kind: "scalar", localName: "profile_id", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "123", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Globally unique id for a profile under user account." } },
            { no: 7, name: "spec_version", kind: "scalar", localName: "spec_version", T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "3.24.0", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Version of the spec." } },
            { no: 8, name: "x_forwarded_for", kind: "scalar", localName: "x_forwarded_for", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "127.0.0.1, 127.0.0.2", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "All ip addresses that the events going through." } },
            { no: 9, name: "app_session_start", kind: "scalar", localName: "app_session_start", opt: true, T: 3 /*ScalarType.INT64*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "1712758592151", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Start time of the session in milliseconds since epoch (unix timestamp)." } },
            { no: 10, name: "app_session_replay_id", kind: "scalar", localName: "app_session_replay_id", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "abc-def-ghi", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "The session replay id from amplitude to be used for session replay api. see: https://www.docs.developers.amplitude.com/session-replay/sdks/standalone/#add-session-replay-id-to-your-events" } },
            { no: 11, name: "user_tier", kind: "scalar", localName: "user_tier", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "paid", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Values to identify user tiers" } }
        ]);
    }
    create(value?: PartialMessage<Core>): Core {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.event_id = "";
        message.event_name = "";
        message.market = "";
        message.spec_version = "";
        if (value !== undefined)
            reflectionMergePartial<Core>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Core): Core {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional string app_session_id */ 1:
                    message.app_session_id = reader.string();
                    break;
                case /* string event_id */ 2:
                    message.event_id = reader.string();
                    break;
                case /* string event_name */ 3:
                    message.event_name = reader.string();
                    break;
                case /* google.protobuf.Timestamp event_time */ 4:
                    message.event_time = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.event_time);
                    break;
                case /* string market */ 5:
                    message.market = reader.string();
                    break;
                case /* optional string profile_id */ 6:
                    message.profile_id = reader.string();
                    break;
                case /* string spec_version */ 7:
                    message.spec_version = reader.string();
                    break;
                case /* optional string x_forwarded_for */ 8:
                    message.x_forwarded_for = reader.string();
                    break;
                case /* optional int64 app_session_start */ 9:
                    message.app_session_start = reader.int64().toString();
                    break;
                case /* optional string app_session_replay_id */ 10:
                    message.app_session_replay_id = reader.string();
                    break;
                case /* optional string user_tier */ 11:
                    message.user_tier = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Core, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional string app_session_id = 1; */
        if (message.app_session_id !== undefined)
            writer.tag(1, WireType.LengthDelimited).string(message.app_session_id);
        /* string event_id = 2; */
        if (message.event_id !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.event_id);
        /* string event_name = 3; */
        if (message.event_name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.event_name);
        /* google.protobuf.Timestamp event_time = 4; */
        if (message.event_time)
            Timestamp.internalBinaryWrite(message.event_time, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string market = 5; */
        if (message.market !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.market);
        /* optional string profile_id = 6; */
        if (message.profile_id !== undefined)
            writer.tag(6, WireType.LengthDelimited).string(message.profile_id);
        /* string spec_version = 7; */
        if (message.spec_version !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.spec_version);
        /* optional string x_forwarded_for = 8; */
        if (message.x_forwarded_for !== undefined)
            writer.tag(8, WireType.LengthDelimited).string(message.x_forwarded_for);
        /* optional int64 app_session_start = 9; */
        if (message.app_session_start !== undefined)
            writer.tag(9, WireType.Varint).int64(message.app_session_start);
        /* optional string app_session_replay_id = 10; */
        if (message.app_session_replay_id !== undefined)
            writer.tag(10, WireType.LengthDelimited).string(message.app_session_replay_id);
        /* optional string user_tier = 11; */
        if (message.user_tier !== undefined)
            writer.tag(11, WireType.LengthDelimited).string(message.user_tier);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message fubo.tv.proto.common.v3.generic.Core
 */
export const Core = new Core$Type();
